export var AfriexUserState;
(function (AfriexUserState) {
    AfriexUserState["BLOCKED"] = "BLOCKED";
    AfriexUserState["UNBLOCKED"] = "UNBLOCKED";
    AfriexUserState["RESTRICTED"] = "RESTRICTED";
    AfriexUserState["NON_ACTION"] = "NON_ACTION";
})(AfriexUserState || (AfriexUserState = {}));
//# sourceMappingURL=SecurityTypes.js.map